@if (logoSrc) {
  <img class="logo-company" [src]="logoSrc" alt="Ondernemingslogo">
} @else {
  <img class="logo-company" src="/assets/images/vwlogo.svg" alt="VolkerWessels logo">
}

